import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  tablePaper: {
    flexShrink: 0,
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    overflow: "hidden"
  },

  headCell: {
    backgroundColor: "#f6f6f7",
    color: "#4b1c46",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    whiteSpace: "nowrap"
  },

  row: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#fbfafb"
    }
  },

  rowSelected: {
    backgroundColor: "rgba(75, 28, 70, 0.06) !important"
  },

  cell: {
    fontSize: "13px",
    color: "#333"
  },

  queueName: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  muted: {
    color: "#8f8a8f"
  },

  stale: {
    fontSize: "13px",
    color: "#8f8a8f"
  },

  failedCount: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#d32f2f"
  },

  badgeRunning: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    backgroundColor: "rgba(63, 125, 63, 0.1)",
    color: "#3f7d3f"
  },

  badgePaused: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    color: "#d32f2f"
  },

  emptyCell: {
    borderBottom: "none",
    padding: "48px 16px"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f"
  }
}));

export default useStyles;
